module.exports = __webpack_public_path__ + "img/SU1F6_new.e3bdb05a.jpg";